import { Button, Table, TableColumns, TableColumnWidth, TableData, TablePreferences, Select, Card, TextBox, IconWarningAlt, SelectOption, Modal, IconTrash, Checkbox, RadioButton, IconXCircle, IconCheckCircle, IconPencil, ListItem, OptionInterface, IconPlus, Tabs, ContextualMenu, IconSave, ButtonGroup, IconInfo, DatePicker, DateRange, IconArchive, IconPower, IconApplication, CustomImage, IconArrowLeft, IconArrowRight, IconEmpty, IconReportAlert } from "@veneer/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import '../../assets/css/views/visualExecution.css';
import moment, { Moment } from "moment";
import PptxGenJS from "pptxgenjs";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import dataListService from "../../services/generalApi/dataList.service";
import { ICountryDto } from "../../models/dto/generalApi/ICountryDto";
import pricesService from "../../services/agendaApi/prices.service";
import { IBrandDto } from "../../models/dto/agendaApi/IBrandDto";
import appointmentService from "../../services/agendaApi/appointment.service";
import { ISubretailDto } from "../../models/dto/agendaApi/ISubretailDto";
import visualExecutionService from "../../services/agendaApi/visualExecution.service";
import { ISubcategoryDto } from "../../models/dto/agendaApi/ISubcategoryDto";
import { ICategoryFilterDto } from "../../models/dto/agendaApi/ICategoryFilterDto";
import ImageService from "../../services/generalApi/image.service";
import { IVisualExecutionPhotoDto } from "../../models/dto/agendaApi/IVisualExecutionPhotoDto";
import Loader from "../../components/Loader/loader";
import productService from "../../services/generalApi/product.service";
import { IGetVisualExecutionPhotosDto } from "../../models/dto/agendaApi/IGetVisualExecutionPhotosDto";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { IPosDto } from "../../models/dto/agendaApi/IPosDto";
import AgendaManagement from "../../services/agendaApi/agendaManagement";
import { IGetStateListDto } from "../../models/dto/userManagementApi/IGetStateListDto";
import { IGetCityListDto } from "../../models/dto/userManagementApi/IGetCityListDto";
import { IMaterialVisualDto } from "../../models/dto/agendaApi/IMaterialVIsualDto";

interface images {
    url: string,
    selected: boolean,
    date: string,
    brandName: string,
    subretail: string,
    posCode: string,
    pointOfSale: string,
    country: string,
    state: string,
    city: string,
    material: string
}

export default function VisualExecution() {
    const [t] = useTranslation("global");
    type SelectValue = number | string | boolean; //CHECK
    const languageId: any = useSelector((state: RootState) => state.languageId);


    const [loadingImages, setLoadingImages] = useState<boolean>(true);

    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");

    const [brands, setBrands] = useState<SelectOption[]>([]);
    const [brandsSelected, setBrandsSelected] = useState<SelectValue[]>([]);

    const [subretails, setSubretails] = useState<SelectOption[]>([]);
    const [subretailsSelected, setSubretailsSelected] = useState<SelectValue[]>([]);
    const [subretailsFiltered, setSubretailsFiltered] = useState<SelectOption[]>([]);

    const [pos, setPos] = useState<SelectOption[]>([]);
    const [posSelected, setPosSelected] = useState<SelectValue[]>([]);
    const [posFiltered, setPosFiltered] = useState<SelectOption[]>([]);

    const [countries, setCountries] = useState<SelectOption[]>([]);
    const [countriesSelected, setCountriesSelected] = useState<SelectValue[]>([]);
    const [countriesFiltered, setCountriesFiltered] = useState<SelectOption[]>([]);

    const [states, setStates] = useState<SelectOption[]>([]);
    const [statesSelected, setStatesSelected] = useState<SelectValue[]>([]);
    const [statesFiltered, setStatesFiltered] = useState<SelectOption[]>([]);

    const [cities, setCities] = useState<SelectOption[]>([]);
    const [citiesSelected, setCitiesSelected] = useState<SelectValue[]>([]);
    const [citiesFiltered, setCitiesFiltered] = useState<SelectOption[]>([]);

    const [categories, setCategories] = useState<SelectOption[]>([]);
    const [categoriesSelected, setCategoriesSelected] = useState<SelectValue[]>([]);
    const [subcategories, setSubcategories] = useState<SelectOption[]>([]);
    const [subcategoriesSelected, setSubcategoriesSelected] = useState<SelectValue[]>([]);
    const [materials, setMaterials] = useState<SelectOption[]>([]);
    const [materialsSelected, setMaterialsSelected] = useState<SelectValue[]>([]);
    const [furnitureTypes, setFurnitureTypes] = useState<SelectOption[]>([]);
    const [furnitureTypesSelected, setFurnitureTypesSelected] = useState<SelectValue[]>([]);
    const [materialsPOP, setMaterialsPOP] = useState<SelectOption[]>([]);
    const [materialsPOPSelected, setMaterialsPOPSelected] = useState<SelectValue[]>([]);

    const [selectAll, setSelectAll] = useState<boolean>(false);
    const [imagesUrl, setImagesUrl] = useState<images[]>([])
    const [imagesSelectedUrl, setImagesSelectedUrl] = useState<images[]>([])

    const [disabledSubretails, setDisabledSubretails] = useState<boolean>(true);
    const [disabledState, setDisabledState] = useState<boolean>(true);
    const [disabledCities, setDisabledCities] = useState<boolean>(true);
    const [disabledPos, setDisabledPos] = useState<boolean>(true);
    const [disabledSubcategory, setDisabledSubcategory] = useState<boolean>(true);
    const [disabledFunctions, setDisabledFunctions] = useState<boolean>(true);
    const [disabledSelectAll, setDisabledSelectAll] = useState<boolean>(true);
    const [disabledFurniture, setDisabledFurtniture] = useState<boolean>(true);
    const [disabledMaterialsPOP, setDisabledMaterialsPOP] = useState<boolean>(true);







    const [showModalExpandImage, setShowModalExpandImage] = useState<boolean>(false);
    const [showModalPreview, setShowModalPreview] = useState<boolean>(false);
    const [showModalClearFilters, setShowModalClearFilters] = useState<boolean>(false);
    const [indexPreview, setIndexPreview] = useState<number>(0);


    const [indexImageSelected, setIndexImageSelected] = useState<number>(NaN);


    useEffect(() => {
        getFiltersData();
        getPhotosData();
        getActualDates();
    }, [])

    useEffect(() => {
        onClearFilters();
        getFiltersData();
    }, [languageId])

    useEffect(() => {
        const materialSelectedTemp = Number(materialsSelected);
        if (materialSelectedTemp === 1) {
            setDisabledFurtniture(false);
            setDisabledMaterialsPOP(true);
            setMaterialsPOPSelected([]);
        } else if (materialSelectedTemp === 2) {
            setDisabledMaterialsPOP(false);
            setDisabledFurtniture(true);
            setFurnitureTypesSelected([]);
        } else {
            setDisabledMaterialsPOP(true);
            setDisabledFurtniture(true);
            setFurnitureTypesSelected([]);
            setMaterialsPOPSelected([]);
        }
    }, [materialsSelected])

    useEffect(() => {
        const imagesSelectedTemp = imagesUrl.filter((item: images) => item.selected !== false);
        setImagesSelectedUrl(imagesSelectedTemp);

        if (imagesSelectedTemp.length > 0) {
            setDisabledFunctions(false);
        } else {
            setDisabledFunctions(true);
        }

        if (imagesUrl.length > 0) {
            setDisabledSelectAll(false);
        } else {
            setDisabledSelectAll(true);
            setSelectAll(false);
        }

    }, [imagesUrl])

    useEffect(() => {
        if (subretailsSelected.length > 0) {
            getPosData();
        } else {
            setPos([]);
            setPosFiltered([]);
            setPosSelected([]);
            setDisabledPos(true);
        }
    }, [subretailsSelected])

    useEffect(() => {
        setStates([]);
        setStatesFiltered([]);
        setStatesSelected([]);
        setDisabledState(true);
        setCities([]);
        setCitiesFiltered([]);
        setCitiesSelected([]);
        setDisabledCities(true);
        setSubretails([]);
        setSubretailsFiltered([]);
        setSubretailsSelected([]);
        setDisabledSubretails(true);
        setPos([]);
        setPosFiltered([]);
        setPosSelected([]);
        setDisabledPos(true);
        if (countriesSelected.length > 0) {
            getStatesAndSubretailsData();
        }
    }, [countriesSelected])

    useEffect(() => {
        if (statesSelected.length > 0) {
            setCities([]);
            setCitiesFiltered([]);
            setCitiesSelected([]);
            setDisabledCities(true);
            getCitiesData();
        } else {
            setCities([]);
            setCitiesFiltered([]);
            setCitiesSelected([]);
            setDisabledCities(true);
        }
    }, [statesSelected])

    useEffect(() => {
        if (categoriesSelected.length > 0 && materialsSelected.length > 0) {
            setSubcategories([]);
            setSubcategoriesSelected([]);
            setDisabledSubcategory(true);
            getSubcategoriesData();
        } else {
            setSubcategories([]);
            setSubcategoriesSelected([]);
            setDisabledSubcategory(true);
        }
    }, [categoriesSelected, materialsSelected])


    const getActualDates = () => {
        const actualDate = new Date();
        const tempEndDate = new Date(actualDate);
        tempEndDate.setMonth(tempEndDate.getMonth() - 1);

        setStartDate(String(tempEndDate));
        setEndDate(String(actualDate));
    }

    const getFiltersData = () => {
        try {
            dataListService.getCountryListBySubregion()
                .then(r => {
                    fillCountries(r);
                })

            pricesService.getBrands()
                .then(r => {
                    fillBrands(r);
                })

            visualExecutionService.getCategories(Number(languageId.value))
                .then(r => {
                    fillCategories(r);
                })

            visualExecutionService.getMaterials(Number(languageId.value))
                .then(r => {
                    fillMaterials(r);
                })
            visualExecutionService.getFurniture(Number(languageId.value))
                .then(r => {
                    fillFurniture(r);
                })
            visualExecutionService.getMaterialsPOP(Number(languageId.value))
                .then(r => {
                    fillMaterialsPOP(r);
                })

        } catch (error) {
            console.error(error);
        }
    }

    const getSubcategoriesData = () => {
        try {
            visualExecutionService.getSubcategories(Number(languageId.value), Number(categoriesSelected), Number(materialsSelected))
                .then(r => {
                    if (r.length > 0) {
                        fillSubcategories(r);
                    }
                })

        } catch (error) {
            console.error(error);
        }
    }

    const formatDate = (date: Date): string => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    const getPhotosData = () => {
        const actualDate = new Date();
        const tempDate = new Date(actualDate);
        tempDate.setMonth(tempDate.getMonth() - 1);

        const getVisualExecution: IGetVisualExecutionPhotosDto = {
            userID: NaN,
            languageID: languageId.value,
            startDate: formatDate(tempDate),
            endDate: formatDate(actualDate)
        }
        try {
            visualExecutionService.getPhotos(getVisualExecution)
                .then(r => {
                    fillPhotosData(r);
                })

        } catch (error) {
            console.error(error);
            setLoadingImages(false);
        }
    }



    const fillCountries = (data: ICountryDto[]) => {

        const dataSort = data.sort((a, b) => {
            if (a.countryName.toLowerCase() < b.countryName.toLowerCase()) {
                return -1;
            }
            if (a.countryName.toLowerCase() > b.countryName.toLowerCase()) {
                return 1;
            }
            return 0;
        });

        const countriesTemp: SelectOption[] = [];

        for (let i = 0; i < dataSort.length; i++) {
            const country: ICountryDto = dataSort[i];
            let countryTemp: SelectOption;
            countryTemp = {
                'value': country.contryId,
                'label': country.countryName,
            }
            countriesTemp.push(countryTemp);
        }
        setCountries(countriesTemp);
        setCountriesFiltered(countriesTemp);
    }

    const fillBrands = (data: IBrandDto[]) => {
        const dataSort = data.sort((a, b) => {
            if (a.brandID === 1) return -1;
            if (b.brandID === 1) return 1;

            if (a.brandName.toLowerCase() < b.brandName.toLowerCase()) return -1;
            if (a.brandName.toLowerCase() > b.brandName.toLowerCase()) return 1;
            return 0;
        });

        const brandsTemp: SelectOption[] = [];

        for (let i = 0; i < dataSort.length; i++) {
            const brand: IBrandDto = dataSort[i];
            let brandTemp: SelectOption;
            brandTemp = {
                'value': brand.brandID,
                'label': brand.brandName,
            }
            brandsTemp.push(brandTemp);
        }
        setBrands(brandsTemp);
    }

    const fillSubretails = (data: ISubretailDto[]) => {
        const subretailsTemp: SelectOption[] = [];

        for (let i = 0; i < data.length; i++) {
            const subretail: ISubretailDto = data[i];
            let subretailTemp: SelectOption;
            subretailTemp = {
                'value': subretail.fieldID,
                'label': subretail.fieldValue,
            }
            subretailsTemp.push(subretailTemp);
        }
        setSubretails(subretailsTemp);
        setSubretailsFiltered(subretailsTemp);
        setDisabledSubretails(false);
    }

    const fillCategories = (data: ICategoryFilterDto[]) => {
        const categoriesTemp: SelectOption[] = [];
        for (let i = 0; i < data.length; i++) {
            const category: ICategoryFilterDto = data[i];
            let categoryTemp: SelectOption;
            categoryTemp = {
                'value': category.categoryID,
                'label': category.categoryName,
            }
            categoriesTemp.push(categoryTemp);
        }
        setCategories(categoriesTemp);
    }

    const fillSubcategories = (data: ISubcategoryDto[]) => {
        const subcategoriesTemp: SelectOption[] = [];

        for (let i = 0; i < data.length; i++) {
            const subcategory: ISubcategoryDto = data[i];
            let subcategoryTemp: SelectOption;
            subcategoryTemp = {
                'value': subcategory.subCategotyID,
                'label': subcategory.subCategoryName,
            }
            subcategoriesTemp.push(subcategoryTemp);
        }
        setSubcategories(subcategoriesTemp);
        setDisabledSubcategory(false);
    }

    const fillMaterials = (data: IMaterialVisualDto[]) => {
        const materialsTemp: SelectOption[] = [];
        for (let i = 0; i < data.length; i++) {
            const material: IMaterialVisualDto = data[i];
            let materialTemp: SelectOption;
            materialTemp = {
                'value': material.materialID,
                'label': material.materialName,
            }
            materialsTemp.push(materialTemp);
        }
        setMaterials(materialsTemp);
    }

    const fillFurniture = (data: IMaterialVisualDto[]) => {
        const materialsTemp: SelectOption[] = [];
        for (let i = 0; i < data.length; i++) {
            const material: IMaterialVisualDto = data[i];
            let materialTemp: SelectOption;
            materialTemp = {
                'value': material.materialID,
                'label': material.materialName,
            }
            materialsTemp.push(materialTemp);
        }
        setFurnitureTypes(materialsTemp);
    }

    const fillMaterialsPOP = (data: IMaterialVisualDto[]) => {
        const materialsTemp: SelectOption[] = [];
        for (let i = 0; i < data.length; i++) {
            const material: IMaterialVisualDto = data[i];
            let materialTemp: SelectOption;
            materialTemp = {
                'value': material.materialID,
                'label': material.materialName,
            }
            materialsTemp.push(materialTemp);
        }
        setMaterialsPOP(materialsTemp);
    }

    const loadImage = async (url: string): Promise<string> => {
        try {
            const response = await ImageService.getBlobImage(url);
            if (response instanceof Blob) {
                const blobUrl = URL.createObjectURL(response);
                return blobUrl;
            } else {
                console.error("Unexpected response type:", response);
                throw new Error(`Unexpected response type: ${response}`);
            }
        } catch (error) {
            console.error("Error fetching the image blob:", error);
            throw error;
        }
    }


    const fillPhotosData = async (photos: IVisualExecutionPhotoDto[]) => {
        try {
            let promises: Promise<images>[] = [];
            for (let photo of photos) {
                const promise = loadImage(photo.photo)
                    .then((blobUrl) => ({
                        url: blobUrl,
                        selected: false,
                        date: photo.date,
                        brandName: photo.brandName,
                        subretail: photo.subretail,
                        posCode: photo.posCode,
                        pointOfSale: photo.pointOfSale,
                        country: photo.country,
                        state: photo.state,
                        city: photo.city,
                        material: photo.material
                    }))
                    .catch((error) => {
                        console.error("Error loading image:", error);
                        return {
                            url: "",
                            selected: false,
                            date: photo.date,
                            brandName: photo.brandName,
                            subretail: photo.subretail,
                            posCode: photo.posCode,
                            pointOfSale: photo.pointOfSale,
                            country: photo.country,
                            state: photo.state,
                            city: photo.city,
                            material: photo.material
                        };
                    });
                promises.push(promise);
            }

            const loadedImages = await Promise.all(promises);
            setImagesUrl(loadedImages.filter((image: images) => image.url !== ""));
        } catch (error) {
            console.error("Error processing images:", error);
            setLoadingImages(false);
        } finally {
            setLoadingImages(false);
        }
    };

    const getPosData = () => {
        try {
            appointmentService.getPosListBySubretailList(String(subretailsSelected))
                .then(r => {
                    if (r.length > 0) {
                        fillPosData(r);
                    }
                })

        } catch (error) {
            console.error(error);
        }
    }

    const fillPosData = (data: IPosDto[]) => {
        const posListTemp: SelectOption[] = [];
        for (let i = 0; i < data.length; i++) {
            const pos: IPosDto = data[i];
            let posTemp: SelectOption;
            posTemp = {
                'value': pos.fieldID,
                'label': pos.fieldValue,
            }
            posListTemp.push(posTemp);
        }
        setPos(posListTemp);
        setPosFiltered(posListTemp);
        setDisabledPos(false);
    }

    const getStatesAndSubretailsData = () => {
        try {
            visualExecutionService.getStatesByCountryList(String(countriesSelected))
                .then(r => {
                    if (r.length > 0) {
                        fillStatesData(r);
                    }
                })

                visualExecutionService.getSubretailsByCountryList(String(countriesSelected))
                .then(r => {
                    fillSubretails(r);
                })

        } catch (error) {
            console.error(error);
        }

    }

    const fillStatesData = (data: IGetStateListDto[]) => {
        const statesTemp: SelectOption[] = [];
        for (let i = 0; i < data.length; i++) {
            const state: IGetStateListDto = data[i];
            let stateTemp: SelectOption;
            stateTemp = {
                'value': state.stateID,
                'label': state.stateName,
            }
            statesTemp.push(stateTemp);
        }
        setStates(statesTemp);
        setStatesFiltered(statesTemp);
        setDisabledState(false);
    }


    const getCitiesData = () => {
        try {
            visualExecutionService.getCitiesByStateList(String(statesSelected))
                .then(r => {
                    if (r.length > 0) {
                        fillCitiesData(r);
                    }
                })

        } catch (error) {
            console.error(error);
        }

    }

    const fillCitiesData = (data: IGetCityListDto[]) => {
        const citiesTemp: SelectOption[] = [];
        for (let i = 0; i < data.length; i++) {
            const city: IGetCityListDto = data[i];
            let cityTemp: SelectOption;
            cityTemp = {
                'value': city.cityID,
                'label': city.cityName,
            }
            citiesTemp.push(cityTemp);
        }
        setCities(citiesTemp);
        setCitiesFiltered(citiesTemp);
        setDisabledCities(false);
    }





    const createPpt = () => {
        if (imagesUrl.some(item => item.selected === true)) {
            const pptx = new PptxGenJS();

            const slideWidth = 10;
            const slideHeight = 5.5;

            const selectedImages = imagesUrl.filter((item) => item.selected !== false);

            for (let i = 0; i < selectedImages.length; i += 4) {
                const slide = pptx.addSlide(); // Crear una nueva diapositiva

                for (let j = 0; j < 4 && (i + j) < selectedImages.length; j++) {
                    const image = selectedImages[i + j];

                    const col = j % 2;
                    const row = Math.floor(j / 2);

                    const x = col * (slideWidth / 2) + 1.5;
                    const y = row * (slideHeight / 2) + 0.5;

                    slide.addImage({
                        path: image.url,
                        x: x,
                        y: y,
                        w: (slideWidth / 2) - 3.0,
                        h: (slideHeight / 2) - 0.5,
                    });
                }
            }

            pptx.writeFile({ fileName: "presentation.pptx" });
        }
    };



    const fetchImage = async (image: images): Promise<Blob> => {
        const response = await fetch(image.url);
        return await response.blob();
    };

    const createZip = async () => {
        if (imagesUrl.some(item => item.selected === true)) {
            const zip = new JSZip();

            try {
                const imageBlobs = await Promise.all(imagesUrl.filter((item: images) => item.selected !== false).map(item => fetchImage(item)));

                imageBlobs.forEach((blob, index) => {
                    zip.file(`image_${index + 1}.jpg`, blob);
                });

                const zipBlob = await zip.generateAsync({ type: "blob" });
                saveAs(zipBlob, "images.zip");
            } catch (error) {
                console.error("Error creating ZIP file:", error);
            }

        }

    };

    const handleChangeSearchSubretail = (value: string) => {
        const filterArray = subretails.filter((element) => {
            if (element.value.toString().toLowerCase().includes(String(value).toLowerCase()) || element.label?.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setSubretailsFiltered(filterArray)
    }

    const handleChangeSearchPos = (value: string) => {
        const filterArray = pos.filter((element) => {
            if (element.value.toString().toLowerCase().includes(String(value).toLowerCase()) || element.label?.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setPosFiltered(filterArray)
    }

    const handleChangeSearchCountry = (value: string) => {
        const filterArray = countries.filter((element) => {
            if (element.value.toString().toLowerCase().includes(String(value).toLowerCase()) || element.label?.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setCountriesFiltered(filterArray)
    }

    const handleChangeSearchState = (value: string) => {
        const filterArray = states.filter((element) => {
            if (element.value.toString().toLowerCase().includes(String(value).toLowerCase()) || element.label?.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setStatesFiltered(filterArray)
    }

    const handleChangeSearchCity = (value: string) => {
        const filterArray = cities.filter((element) => {
            if (element.value.toString().toLowerCase().includes(String(value).toLowerCase()) || element.label?.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setCitiesFiltered(filterArray)
    }



    const handleChangeStartDate = (date: moment.Moment) => {
        date !== null && setStartDate(String(date));

    };

    const handleChangeEndDate = (date: moment.Moment) => {
        date !== null && setEndDate(String(date));

    };


    const handleChangeSelectAll = () => {
        const imagesTemp = imagesUrl.map(image => ({
            ...image,
            selected: !selectAll
        }));
        setSelectAll(!selectAll);
        setImagesUrl(imagesTemp);
    }

    const handleChangeSelected = (index: number) => {
        const imagesTemp = [...imagesUrl];
        imagesTemp[index].selected = !imagesTemp[index].selected;
        setImagesUrl(imagesTemp);
    }

    const moveLeft = () => {
        if (indexPreview > 0) {
            setIndexPreview(indexPreview - 1)
        }
    }

    const moveRight = () => {
        const maxNumber = imagesSelectedUrl.length - 1;
        if (indexPreview < maxNumber) {
            setIndexPreview(indexPreview + 1)
        }
    }

    const moveLeftImages = () => {
        if (indexImageSelected > 0) {
            setIndexImageSelected(indexImageSelected - 1)
        }
    }

    const moveRightImages = () => {
        const maxNumber = imagesUrl.length - 1;
        if (indexImageSelected < maxNumber) {
            setIndexImageSelected(indexImageSelected + 1)
        }
    }

    const expandImage = (index: number) => {
        setShowModalExpandImage(true)
        setIndexImageSelected(index)
    }

    const onCloseExpandImage = () => {
        setIndexImageSelected(NaN);
        setShowModalExpandImage(false)
    }

    const handleChangeBrands = (value: SelectValue) => {
        const brandsCopy = [...brandsSelected];
        const isOptionSelected = brandsCopy.includes(value);
        if (isOptionSelected) {
            const index = brandsCopy.indexOf(value);
            brandsCopy.splice(index, 1);
        } else {
            brandsCopy.push(value);
        }
        setBrandsSelected(brandsCopy)
    }

    const handleChangeSubretails = (value: SelectValue) => {
        const subretailsCopy = [...subretailsSelected];
        const isOptionSelected = subretailsCopy.includes(value);
        if (isOptionSelected) {
            const index = subretailsCopy.indexOf(value);
            subretailsCopy.splice(index, 1);
        } else {
            subretailsCopy.push(value);
        }
        setSubretailsSelected(subretailsCopy)
    }

    const handleChangePos = (value: SelectValue) => {
        const posCopy = [...posSelected];
        const isOptionSelected = posCopy.includes(value);
        if (isOptionSelected) {
            const index = posCopy.indexOf(value);
            posCopy.splice(index, 1);
        } else {
            posCopy.push(value);
        }
        setPosSelected(posCopy)
    }

    const handleChangeCountries = (value: SelectValue) => {
        const countriesCopy = [...countriesSelected];
        const isOptionSelected = countriesCopy.includes(value);
        if (isOptionSelected) {
            const index = countriesCopy.indexOf(value);
            countriesCopy.splice(index, 1);
        } else {
            countriesCopy.push(value);
        }
        setCountriesSelected(countriesCopy)
    }

    const handleChangeStates = (value: SelectValue) => {
        const statesCopy = [...statesSelected];
        const isOptionSelected = statesCopy.includes(value);
        if (isOptionSelected) {
            const index = statesCopy.indexOf(value);
            statesCopy.splice(index, 1);
        } else {
            statesCopy.push(value);
        }
        setStatesSelected(statesCopy)
    }

    const handleChangeCities = (value: SelectValue) => {
        const citiesCopy = [...citiesSelected];
        const isOptionSelected = citiesCopy.includes(value);
        if (isOptionSelected) {
            const index = citiesCopy.indexOf(value);
            citiesCopy.splice(index, 1);
        } else {
            citiesCopy.push(value);
        }
        setCitiesSelected(citiesCopy)
    }

    const handleChangeFurnitures = (value: SelectValue) => {
        const furnituresCopy = [...furnitureTypesSelected];
        const isOptionSelected = furnituresCopy.includes(value);
        if (isOptionSelected) {
            const index = furnituresCopy.indexOf(value);
            furnituresCopy.splice(index, 1);
        } else {
            furnituresCopy.push(value);
        }
        setFurnitureTypesSelected(furnituresCopy)
    }

    const handleChangeMaterialsPOP = (value: SelectValue) => {
        const materialsPOPCopy = [...materialsPOPSelected];
        const isOptionSelected = materialsPOPCopy.includes(value);
        if (isOptionSelected) {
            const index = materialsPOPCopy.indexOf(value);
            materialsPOPCopy.splice(index, 1);
        } else {
            materialsPOPCopy.push(value);
        }
        setMaterialsPOPSelected(materialsPOPCopy)
    }

    const onClearSubretails = () => {
        setSubretailsSelected([]);
        setPos([]);
        setPosFiltered([]);
        setPosSelected([]);
        setDisabledPos(true);
    }

    const getVisualExecutionPhotos = () => {
        setLoadingImages(true);
        const startDateTemp = new Date(startDate);
        const endDateTemp = new Date(endDate);

        const getVisualExecution: IGetVisualExecutionPhotosDto = {
            userID: NaN,
            languageID: Number(languageId.value),
            startDate: formatDate(startDateTemp),
            endDate: formatDate(endDateTemp),
            brandList: String(brandsSelected),
            countryList: String(countriesSelected),
            subRetailList: String(subretailsSelected),
            posList: String(posSelected),
            stateList: String(statesSelected),
            cityList: String(citiesSelected),
            categoryList: String(categoriesSelected),
            subcategoryList: String(subcategoriesSelected),
            furnitureList: String(furnitureTypesSelected),
            materialList: String(materialsPOPSelected)
        }
        try {
            visualExecutionService.getPhotos(getVisualExecution)
                .then(r => {
                    fillPhotosData(r);
                })

        } catch (error) {
            console.error(error);
            setLoadingImages(false);
        }
    }

    const onApplyFilters = () => {
        getVisualExecutionPhotos();
    }

    const onClearFilters = () => {
        setShowModalClearFilters(false);
        setLoadingImages(true);
        getActualDates();
        setBrandsSelected([]);
        setSubretailsSelected([]);
        setPos([]);
        setPosFiltered([]);
        setPosSelected([]);
        setDisabledPos(true);
        setCountriesSelected([]);
        setStates([]);
        setStatesFiltered([]);
        setStatesSelected([]);
        setDisabledState(true);
        setCities([]);
        setCitiesFiltered([]);
        setCitiesSelected([]);
        setDisabledCities(true);
        setCategoriesSelected([]);
        setMaterialsSelected([]);
        setSubcategories([]);
        setSubcategoriesSelected([]);
        setDisabledSubcategory(true);
        setMaterialsPOPSelected([]);
        setFurnitureTypesSelected([]);
        getPhotosData();
    }


    const onCloseModalPreview = () => {
        setShowModalPreview(false);
        setIndexPreview(0);
    }



    return (
        <div className="visualExecution">
            <h4 className="visualExecutionTittle">{t("header.visualExecution")}</h4>

            <div className="visualExecutionDivs">
                <div className="visualExecutionDivImages">
                    <div className="visualExecutionDivImagesTop">
                        <ButtonGroup>
                            <Button disabled={disabledFunctions} onClick={createPpt} leadingIcon={<IconApplication />}>{t("header.downloadPPT")}</Button>
                            <Button disabled={disabledFunctions} onClick={createZip} leadingIcon={<IconArchive />}>{t("header.downloadZIP")}</Button>
                            <Button disabled={disabledFunctions} onClick={() => setShowModalPreview(true)}   >{t("header.preview")}</Button>
                        </ButtonGroup>
                        <Checkbox
                            className="visualExecutionDivImagesCheckbox"
                            id="surveyEditorModalCheckbox"
                            value={selectAll}
                            checked={selectAll}
                            onChange={handleChangeSelectAll}
                            label={t("header.selectAll")}
                            disabled={disabledSelectAll}
                        />

                    </div>

                    <div className={imagesUrl.length > 0 ? "visualExecutionDivImagesBottom" : "visualExecutionDivImagesBottomEmpty"}>
                        {loadingImages && <Loader />}
                        {imagesUrl.length > 0 ? imagesUrl.map((item, index) => {
                            return (
                                <div className="visualExecutionDivImagesBottomDiv">
                                    <Checkbox
                                        className="visualExecutionDivImagesBottomCheckbox"
                                        id="visualExecutionDivImagesBottomCheckbox"
                                        value={item.selected}
                                        checked={item.selected}
                                        onChange={() => handleChangeSelected(index)}
                                        label={t("header.select")}
                                    />
                                    <div className="visualExecutionDivImagesBottomDivImage">
                                        <CustomImage
                                            style={{
                                                cursor: 'pointer',
                                                borderRadius: '6px',
                                                width: '100%',
                                                height: 'auto',
                                                maxWidth: '300px',
                                                minWidth: '100px',
                                                objectFit: 'cover',
                                                overflow: 'hidden'
                                            }}
                                            onClick={() => expandImage(index)} size={200} quietArea={0}
                                            src={item.url}
                                        />

                                    </div>


                                </div>

                            )
                        })
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', marginTop: '10%' }}>
                                <IconWarningAlt size={120} />
                                <b>{t("header.messageNoResultsVisualExecution")}</b>
                            </div>
                        }

                    </div>


                </div>

                <div className="visualExecutionDivFilters">
                    <h5>{t("header.filters")}</h5>
                    <ButtonGroup className="visualExecutionDivFiltersButtons">
                        <Button onClick={() => setShowModalClearFilters(true)}   >{t("header.clearFilters")}</Button>
                        <Button onClick={onApplyFilters}   >{t("header.applyFilters")}</Button>
                    </ButtonGroup>

                    <DatePicker
                        className="visualExecutionDatePicker"
                        clearIcon={false}
                        blockFutureDates
                        calendarOrientation={['right', 'down']}
                        label={t("header.stardDate")}
                        format="LL"
                        monthYearNavigation
                        onChange={(date) => handleChangeStartDate(date as moment.Moment)}
                        placeholder="MM/DD/YYYY"
                        value={startDate}

                    />
                    <DatePicker
                        className="visualExecutionDatePicker"
                        clearIcon={false}
                        blockFutureDates
                        calendarOrientation={['right', 'down']}
                        label={t("header.endDate")}
                        format="LL"
                        monthYearNavigation
                        onChange={(date) => handleChangeEndDate(date as moment.Moment)}
                        placeholder="MM/DD/YYYY"
                        value={endDate}
                    />

                    <div className="visualExecutionDivFiltersDiv">


                        <Select
                            className="visualExecutionSelect"
                            label={t("header.brands")}
                            onChange={e => handleChangeBrands(e.value)}
                            onClear={() => setBrandsSelected([])}
                            options={brands}
                            value={brandsSelected}
                            placement="bottom-start"
                            multiple
                        />
                        <Select
                            className="visualExecutionSelect"
                            label={t("header.countries")}
                            onChange={e => handleChangeCountries(e.value)}
                            onClear={() => setCountriesSelected([])}
                            options={countriesFiltered}
                            value={countriesSelected}
                            placement="bottom-start"
                            multiple
                            showSearch
                            onSearch={handleChangeSearchCountry}
                        />
                        <Select
                            className="visualExecutionSelect"
                            label={t("header.subretails")}
                            onChange={e => handleChangeSubretails(e.value)}
                            onClear={onClearSubretails}
                            options={subretailsFiltered}
                            value={subretailsSelected}
                            placement="bottom-start"
                            multiple
                            showSearch
                            onSearch={handleChangeSearchSubretail}
                            disabled={disabledSubretails}

                        />
                        <Select
                            className="visualExecutionSelect"
                            label={t("header.pos")}
                            onChange={e => handleChangePos(e.value)}
                            onClear={() => setPosSelected([])}
                            options={posFiltered}
                            value={posSelected}
                            placement="bottom-start"
                            disabled={disabledPos}
                            multiple
                            showSearch
                            onSearch={handleChangeSearchPos}
                        />

                        <Select
                            className="visualExecutionSelect"
                            label={t("header.states")}
                            onChange={e => handleChangeStates(e.value)}
                            onClear={() => setStatesSelected([])}
                            options={statesFiltered}
                            value={statesSelected}
                            placement="bottom-start"
                            disabled={disabledState}
                            multiple
                            showSearch
                            onSearch={handleChangeSearchState}
                        />
                        <Select
                            className="visualExecutionSelect"
                            label={t("header.cities")}
                            onChange={e => handleChangeCities(e.value)}
                            onClear={() => setCitiesSelected([])}
                            options={citiesFiltered}
                            value={citiesSelected}
                            placement="bottom-start"
                            disabled={disabledCities}
                            multiple
                            showSearch
                            onSearch={handleChangeSearchCity}
                        />
                        <Select
                            className="visualExecutionSelect"
                            label={t("header.category")}
                            onChange={e => setCategoriesSelected([e.value])}
                            onClear={() => setCategoriesSelected([])}
                            options={categories}
                            value={categoriesSelected}
                            placement="bottom-start"
                        />
                        <Select
                            className="visualExecutionSelect"
                            label={t("header.typeOfMaterial")}
                            onChange={e => setMaterialsSelected([e.value])}
                            onClear={() => setMaterialsSelected([])}
                            options={materials}
                            value={materialsSelected}
                            placement="bottom-start"
                        />
                        <Select
                            className="visualExecutionSelect"
                            label={t("header.subcategory")}
                            onChange={e => setSubcategoriesSelected([e.value])}
                            onClear={() => setSubcategoriesSelected([])}
                            options={subcategories}
                            value={subcategoriesSelected}
                            placement="bottom-start"
                            disabled={disabledSubcategory}
                        />
                        <Select
                            className="visualExecutionSelect"
                            label={t("header.furnitureType")}
                            onChange={e => handleChangeFurnitures(e.value)}
                            onClear={() => setFurnitureTypesSelected([])}
                            options={furnitureTypes}
                            value={furnitureTypesSelected}
                            placement="bottom-start"
                            multiple
                            disabled={disabledFurniture}
                        />
                        <Select
                            className="visualExecutionSelect"
                            label={t("header.materialPOP")}
                            onChange={e => handleChangeMaterialsPOP(e.value)}
                            onClear={() => setMaterialsPOPSelected([])}
                            options={materialsPOP}
                            value={materialsPOPSelected}
                            placement="bottom-start"
                            multiple
                            disabled={disabledMaterialsPOP}
                        />
                    </div>



                </div>

            </div>

            <div style={{ position: 'relative' }}>
                <Modal
                    className="visualExecutionModalExpandImage"
                    align="center"
                    id="visualExecutionModalExpandImage"
                    show={showModalExpandImage}
                    onClose={onCloseExpandImage}
                    closeButton
                    title={t("header.image") + " " + (indexImageSelected + 1)}
                >
                    <div className="visualExecutionModalExpandImageDiv">
                        <Button onClick={() => moveLeftImages()} appearance="ghost" leadingIcon={<IconArrowLeft />} />

                        <div className="visualExecutionModalExpandImageDivs">

                            {imagesUrl[indexImageSelected] && <>
                                <div className="visualExecutionSelectModalExpandImageImg">
                                    <CustomImage size={300} quietArea={0}
                                        src={imagesUrl[indexImageSelected].url}
                                    />

                                </div>
                                <div className="visualExecutionModalExpandImageData">
                                    <h6><strong>{t("header.imageInformation")}</strong></h6>
                                    <br />
                                    <p><strong>{t("header.date")}:</strong> {imagesUrl[indexImageSelected]!.date}</p>
                                    <p><strong>{t("header.brand")}:</strong> {imagesUrl[indexImageSelected]!.brandName}</p>
                                    <p><strong>{t("header.subRetail")}:</strong> {imagesUrl[indexImageSelected]!.subretail}</p>
                                    <p><strong>{t("header.pos")}:</strong> {imagesUrl[indexImageSelected]!.pointOfSale}</p>
                                    <p><strong>{t("header.country")}:</strong> {imagesUrl[indexImageSelected]!.country}</p>
                                    <p><strong>{t("header.state")}:</strong> {imagesUrl[indexImageSelected]!.state}</p>
                                    <p><strong>{t("header.city")}:</strong> {imagesUrl[indexImageSelected]!.city}</p>
                                    <p><strong>{t("header.material")}:</strong> {imagesUrl[indexImageSelected]!.material}</p>
                                </div></>}

                        </div>
                        <Button onClick={() => moveRightImages()} appearance="ghost" leadingIcon={<IconArrowRight />} />
                    </div>
                </Modal>
            </div>

            <div style={{ position: 'relative' }}>
                <Modal
                    className="visualExecutionModalPreview"
                    align="center"
                    id="visualExecutionSelectModalPreview"
                    show={showModalPreview}
                    onClose={onCloseModalPreview}
                    closeButton
                    title={t("header.preview")}
                >

                    <div className="visualExecutionModalPreviewDivs">
                        <Button onClick={() => moveLeft()} appearance="ghost" leadingIcon={<IconArrowLeft />} />
                        <div className="visualExecutionModalPreviewImage">
                            {imagesSelectedUrl && <CustomImage size={300} quietArea={0}
                                src={imagesSelectedUrl[indexPreview]?.url}
                            />}

                        </div>
                        <Button onClick={() => moveRight()} appearance="ghost" leadingIcon={<IconArrowRight />} />


                    </div>
                    <b>{indexPreview + 1}</b>

                </Modal>
            </div>

            <div style={{ position: 'relative' }}>
                <Modal
                    className="visualExecutionModalClearFilters"
                    align="center"
                    id="visualExecutionModalClearFilters"
                    show={showModalClearFilters}
                    footer={(
                        <ButtonGroup className="visualExecutionModalClearFiltersButtongroup">
                            <Button onClick={onClearFilters}>{t("header.confirm")}</Button>
                            <Button onClick={() => setShowModalClearFilters(false)} appearance="secondary">{t("header.cancel")}</Button>
                        </ButtonGroup>
                    )}
                    title={t("header.clearFilters")}
                >
                    <b>{t("header.messageClearFilters")}</b>
                </Modal>
            </div>




        </div>
    );
}